export var EContainerEHRIntegrationTab = /*#__PURE__*/function (EContainerEHRIntegrationTab) {
  EContainerEHRIntegrationTab["SystemResources"] = "system-resources";
  EContainerEHRIntegrationTab["Settings"] = "settings";
  return EContainerEHRIntegrationTab;
}({});